import React from 'react';
import * as componentStyle from './caseStudyOurApproach.module.scss';
import { Heading } from '../../../interface/header.interface';
import { GatsbyImageInterface } from '../../../interface/image.interface';
import HeadingComponent from '../../HeadingComponent/HeadingComponent';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';


interface ImageInterface {
  image: GatsbyImageInterface | null;
  altText: string | null;
}
interface ContextInterface {
  heading: string | null;
  subHeading: string | null;
  description: string | null;
  sectionImage: ImageInterface | null;
}
export interface CaseStudyOurApproachProps {
  heading: Heading[] | null;
  description: string | null;
  context: ContextInterface[] | null;
}

export default function CaseStudyOurApproach({ data }: { data: CaseStudyOurApproachProps | null }) {
  return (
    <>
      {data?.heading && (
        <section className={componentStyle.caseStudyOurApproach}>
          <div className={componentStyle.caseStudyOurApproach__container}>
            <div className={componentStyle.caseStudyOurApproach__headingArea}>
              {data?.heading && <HeadingComponent data={data?.heading} textAlign='center' />}
              {data?.description && <div className={componentStyle.caseStudyOurApproach__description} dangerouslySetInnerHTML={{ __html: data?.description }}></div>}
            </div>

            
            {data?.context?.map((item, index) => (
              <div key={`item-${index}`} className={componentStyle.caseStudyOurApproach__contextArea}>
                <div className={componentStyle.caseStudyOurApproach__contextImage}>
                  {item?.sectionImage?.image && 
                    <div className={componentStyle.caseStudyOurApproach__contextImageArea}>
                      <GatsbyImage image={getImage(item.sectionImage.image.localFile) as IGatsbyImageData} alt={item.sectionImage.altText || 'N/A'}  />
                    </div>
                  }
                </div>

                <div className={componentStyle.caseStudyOurApproach__contextData}>
                  {item?.heading && <h3 className={componentStyle.caseStudyOurApproach__contextHeading}>{item?.heading}</h3>}
                  {item?.subHeading && <h4 className={componentStyle.caseStudyOurApproach__contextSubHeading}>{item?.subHeading}</h4>}
                  {item?.description && 
                    <div className={componentStyle.caseStudyOurApproach__contextDescription} dangerouslySetInnerHTML={{ __html: item.description }}></div>
                  }
                </div>
              </div>
            ))}

          </div>
        </section>
      )}
    </>
  )
}
